import { useCallback } from "react";
import qq from "fine-uploader/lib/core/s3.js";
import { LimitSizeModal } from "components/Pages/Uploader/ModalsAndPopups/LimitSize/LimitSizeModal.tsx";
import { beforeUploadAction } from "./uploaderAPI.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";

interface useSizeLimitI {
  setEnableSubmit?: (value: boolean) => void;
  body?: {
    SendOwnerEmail: string;
    ShareToEmailSubjectTitle: string;
  };
  handleRetryUpload?: (e: any, message: string) => void;
  getFormValuesRef: any;
}

const useSizeLimitModal = ({
  setEnableSubmit,
  body,
  handleRetryUpload,
  getFormValuesRef,
}: useSizeLimitI) => {
  const { getHtmlByKey, getLanguageCulture, getTextByKey } = useContent();

  const {
    setJumboCode,
    getSize,
    setHideSubmit,
    setUploading,
    getIsUppy,
    uploaderGetFiles,
    getUploadId,
    uplaoderStartUpload,
    uploaderSetMeta,
  } = useUploader();

  const { setModal } = useModal();

  const { addToast } = useToasts();

  const getUserEmail = async () => {
    if (body) {
      return body.SendOwnerEmail;
    }
    if (getFormValuesRef.current) {
      const res = await getFormValuesRef.current();
      return res.values.userEmail;
    }
  };

  const modalHandler = useCallback(
    async ({ isSaved }: { isSaved: boolean }) => {
      const email = await getUserEmail();
      setEnableSubmit && setEnableSubmit(false);
      setModal({
        modal: LimitSizeModal,
        modalSize: " uploader-modal",
        props: {
          setConfirmCode: setJumboCode,
          size: getSize(),
          isSaved: isSaved,
          userEmail: email,
          uploadStart: async (code: string) => {
            setHideSubmit(true);
            setUploading(true);

            if (body?.ShareToEmailSubjectTitle) {
              document.title = `${getHtmlByKey("uploading-title")} ${
                body.ShareToEmailSubjectTitle || ""
              }: 0%`;
            }

            await uploaderSetMeta({
              getUniqueId: qq.getUniqueId,
              filesOwnerEmail: email,
              callback: () => {
                addToast(getTextByKey("uploading-error-uuid"), {
                  appearance: "error",
                });
              },
            });

            const totalSize = getIsUppy()
              ? getSize()
              : uploaderGetFiles().reduce(
                  (acc: number, file: { size: number }) => acc + file.size,
                  0
                );

            const res = await beforeUploadAction({
              files: uploaderGetFiles(),
              uploadId: getUploadId(),
              lang: getLanguageCulture(),
              userMail: email,
              totalSize: totalSize,
              uplaoderStartUpload: uplaoderStartUpload,
              code: code,
              isSaved: isSaved,
            });

            if (res?.status === "error") {
              handleRetryUpload &&
                handleRetryUpload(
                  null,
                  "ReactValidateUploadSizeHomePage from LimitSizeModal error"
                );
              return {
                status: "error",
                message: "uploading-error-title",
              };
            }
          },
        },
      });
      setTimeout(() => {
        setEnableSubmit && setEnableSubmit(true);
      }, 1000);
    },
    [
      getSize(),
      body?.SendOwnerEmail,
      body?.ShareToEmailSubjectTitle,
      getFormValuesRef,
    ]
  );

  return modalHandler;
};

export default useSizeLimitModal;
